var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecallsWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0004 19.5614C14.0294 19.5614 13.334 20.2002 13.334 21.1452C13.334 22.092 14.0294 22.7504 15.0004      22.7504C15.9697 22.7504 16.6668 22.092 16.6668 21.1452C16.6668 20.2002 15.9697 19.5614 15.0004 19.5614ZM15.7173      17.876C15.9071 15.9007 16.2649 10.4907 16.2649 8.94948V8.12561H13.7754V8.94948C13.7754 10.4907 14.1349 15.9007 14.3247      17.876H15.7173ZM15 0C14.402 0 13.8493 0.312839 13.5537 0.818949L0.219021 23.5694C-0.0749521 24.0722 -0.0732722 24.6897      0.225741 25.1909C0.524754 25.6921 1.07238 26 1.66705 26H28.333C28.9276 26 29.4752 25.6921 29.7743 25.1909C30.0733 24.6897      30.075 24.0722 29.781 23.5694L16.4463 0.818949C16.1507 0.312839 15.598 0 15 0Z",
    fill: "#BA4E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecallsWarning);
export default __webpack_public_path__ + "static/media/recalls-warning.7a35ffa5561f930f609a813527c4d7fc.svg";
export { ForwardRef as ReactComponent };